var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-range-slider',{staticClass:"px-0",attrs:{"min":_vm.min,"max":_vm.max,"height":3,"dot-width":25,"dot-height":25,"tooltip":"hover"},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }